export default __webpack_public_path__ + "static/media/4-TranquilMooring.61f12725.jpeg";